// src/api/ticketStatusTransitionService.js
// -----------------------------------------------------------------------------
// CRUD calls for Ticket_Status_Transition_TBL (Additional Requirement: status
// transition rules - which role may move a ticket from one status to another
// on a project). The API enforces these rules on every status change.
// -----------------------------------------------------------------------------
import axiosClient from './axiosClient';

const toFrontend = (data) => ({
  transitionID: data?.transitionId ?? data?.transitionID ?? 0,
  projectID: data?.projectId ?? data?.projectID ?? 0,
  fromStatusID: data?.fromStatusId ?? data?.fromStatusID ?? 0,
  toStatusID: data?.toStatusId ?? data?.toStatusID ?? 0,
  allowedRoleID: data?.allowedRoleId ?? data?.allowedRoleID ?? 0,
});

const toBackend = (data) => ({
  transitionId: Number(data?.transitionID || 0),
  projectId: Number(data?.projectID || 0),
  fromStatusId: Number(data?.fromStatusID || 0),
  toStatusId: Number(data?.toStatusID || 0),
  allowedRoleId: Number(data?.allowedRoleID || 0),
});

const unwrap = (res) => res?.data?.data || res?.data;

const ticketStatusTransitionService = {
  getAll: () =>
    axiosClient.get('/TicketStatusTransition').then((res) => {
      const list = unwrap(res);
      return { data: (Array.isArray(list) ? list : []).map(toFrontend) };
    }),

  getById: (id) =>
    axiosClient.get(`/TicketStatusTransition/${id}`).then((res) => ({ data: toFrontend(unwrap(res)) })),

  create: (payload) =>
    axiosClient
      .post('/TicketStatusTransition', { ...toBackend(payload), transitionId: 0 })
      .then((res) => ({ data: toFrontend(unwrap(res)) })),

  update: (id, payload) =>
    axiosClient
      .put('/TicketStatusTransition', toBackend({ ...payload, transitionID: id }))
      .then((res) => ({ data: toFrontend(unwrap(res)) })),

  remove: (id) => axiosClient.delete(`/TicketStatusTransition/${id}`),
};

export default ticketStatusTransitionService;
